// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatbot-container-veg {
    margin-left: 0px;
    width: 1000vh;
    margin-top: 20px;
    
   }

   .chatboticon-v {
  
    float: right;
    margin-left: 60px;
  }

  .top-sum-v{
    width: 5%;
    margin-left: 850px;
    float: right;
    
    
  }
   
   .right-section-chat-veg {
     /* background-color: rgba(0, 0, 0, 0.1); */
     border-radius: 10px;
     /* min-width: 550; */
     /* margin-top: 20px; */
     /* padding: 5px; */
     /* margin-bottom: 20px; */
     /* margin-left: 5px; */
     height: 470px;
     /* border-radius: 8px; */
     border-width: 1px;
     border-style: solid;
     border-color: rgba(116, 123, 169, 1);
     background-color: rgba(255, 255, 255, 0.05);
     /* max-height: 450px; */
   }
   
   .left-section-chat-veg {
     background-color: rgba(30, 32, 61, 1);
     border: 1px solid rgba(107, 92, 209, 1);
     border-radius: 10px;
     /* min-width: 500px; */
     /* min-width: 680px; */
     /* margin-left: 7px;
     margin-top: 20px;
     margin-bottom: 20px;
     margin-right: 20px; */
     /* max-height: 450px; */
     display: flex;
     flex-direction: column;
     height: 470px;
   
   }
   
   .title-chart-veg {
     margin-top: 5px;
     margin-left: 10px;
     font-size: 13px;
     font-family: Graphik;
     font-weight: 400;
   }
   
   .chat-input-container-chart-veg {
     display: flex;
   }
   
   .text-chart-veg {
     margin-top: 30px;
     color: white;
     background-color: rgba(37, 40, 67, 1);
     font-size: 14px;
     font-weight: 300;
     margin-right: 5px;
     font-family: Graphik;
     padding-left: 7px;
     height: 50px;
     width:100%;
     border-radius: 10px;
     border: 1px solid rgba(116, 123, 169, 1);
     background-color: rgba(37, 40, 67, 1);
     text-align:left;
   }
   
   .chat-input-chart-veg {
     margin-left: 10px;
     margin-right: 10px;
     margin-top: 10px;
     padding: 2px;
     width: 100%;
     font-family: 'Graphik', sans-serif;
     color: black;
     font-size: 14px;
     height: 10%;
   }
   .loader-doa {
     display: flex;
     justify-content: center;
     align-items: center;
     height: 40px;
   }
   
   .loader-f-doa {
     display: flex;
     flex-direction: row;
     justify-content: center;
     align-items: center;
     height: 40px;
     width: 187px;
     padding-top: 80px;
   }
   
   .dot-doa {
     width: 10px;
     height: 10px;
     margin: 0 5px;
     border-radius: 50%;
     display: inline-block;
     animation: bounce 1.4s infinite ease-in-out;
   }
   
   .red-doa {
     background-color: #8070d4;
     /* Red color */
     animation-delay: -0.32s;
   }
   
   .green-doa {
     background-color: #8070d4;
     /* Green color */
     animation-delay: -0.16s;
   }
   
   .blue-doa {
     background-color: #8070d4;
     /* Blue color */
   }
   
   .loading-text-doa {
     background-color: #3498db;
     /* Red color */
     animation-delay: -0.48s;
   }
   
   @keyframes bounce {
   
     0%,
     80%,
     100% {
       transform: translateY(0);
     }
   
     40% {
       transform: translateY(-10px);
     }
   }
   
   .img1-chart-veg {
     text-align: right;
   }
   
   .top-part-chart-veg {
     height: 40px;
     width: 100%;
     border-top-left-radius: 10px;
     border-top-right-radius: 10px;
     display: flex;
     flex-direction: row;
     background-color: rgb(54, 54, 89);
     padding: 5px;
     color: white;
     font-size: 13px;
     font-weight: 500;
   }
   
   .middile-part-chart-veg {
     height: auto;
     color: white;
     font-size: 10px;
   }
   
   .user-message-container-veg {
     display: flex;
     justify-content: flex-start;
     /* Align to the left for user messages */
     margin: 5px 0;
   }
   
   .bot-message-container-veg {
     display: flex;
     justify-content: flex-end;
     /* Align to the right for bot messages */
     margin: 5px 0;
   }
   
   .message-text-chart-veg {
     padding: 10px 10px 10px 10px;
     font-size: 14px;
     color: white;
     border-radius: 5px;
     max-width: 1000px;
     width: fit-content;
     margin-left: 30px;
   }
   
   /* Additional styles for user and bot message containers, e.g., background color, border, etc. */
   
   .chat-messages-c-veg {
     height: 100%;
     color: white;
     font-size: 16px;
     overflow-y: scroll;
   }
   .section::-webkit-scrollbar-thumb {
     border: 5px solid transparent;
     border-radius: 100px;
     background-color: #8070d4;
     background-clip: content-box;
   }
   .chat-message-chart-veg {
     display: flex;
     border-radius: 5px;
     flex-direction: row;
   }
   
   .chat-message-chart-veg.user-c-veg {
     text-align: left;
   }
   
   .user-c-veg {
     /* align-items: end; */
     min-width: 50px;
     margin-top: 10px;
     margin-bottom: 10px;
     /* margin-right:10px; */
     /* margin-left: 100px; */
     text-align: left;
     position: relative;
     max-width: 500px;
     /* padding: 10px; */
     width: fit-content;
     float: left;
   }
   
   .bot-c-veg {
     min-width: 50px;
     margin-top: 10px;
     position: relative;
     max-width: 640px;
     margin-bottom: 10px;
     /* min-height: 60px; */
     /* max-height: 100%; */
     /* height: fit-content; */
     /* display: block; */
     /* overflow: auto; */
     padding: 10px;
     color: white;
     text-align: left;
     /* margin-right: 30px; */
     width: fit-content;
     float: left;
   }
   
   .bg-user-veg {
     background-color: rgba(116, 123, 169, 1);
     border-radius: 0px 10px 10px 10px;
     border-style: icon solid;
     min-width: 50px;
     margin-left: 40px;
   }
   
   .bg-bot-veg {
     background-color: rgba(45, 50, 90, 1);
     border-radius: 0px 10px 10px 10px;
     min-width: 50px;
     max-width: 1200px;
     /* height: auto; */
   }
   
   .icon-chat-user-veg {
     width: 25px;
     position: absolute;
     margin-left: 10px;
     /* margin-right: 10px; */
     /* bottom: -15px; */
     /* left: -5px; */
   }
   
   .icon-chat-bot-veg {
     width: 25px;
     position: absolute;
     /* margin-right: 50px; */
     /* bottom: -15px; */
     /* right: -5px; */
   }
   
   .key-table-cb-doa {
     color: white;
     padding-top: 15px;
     padding-bottom: 5px;
     font-size: 13px;
     font-family: Graphik;
     font-weight: 400;
     margin-top: 27px;
     margin-left: 6px;
     line-height: 40px;
     margin-bottom: 10px;
   }
   
   .topside-doa {
     display: flex;
     flex-direction: row;
     margin-bottom: 10px;
   }
   
   .chat-table-doa {
     width: 20px;
   }
   
   .detected-ct-doa {
     background-image: linear-gradient(to right, rgba(72, 48, 239, 1), rgba(128, 69, 237, 1));
     height: 140px;
     width: 200px;
     margin-left: 15px;
     border-radius: 8px;
     margin-top: 10px;
     margin-bottom: 10px;
   }
   .heading-dt-doa{
     color: white;
     font-size: 14px;
     height: 30px;
     font-family: Graphik;
     font-weight: 500;
   text-align: center;
   width: 150px;
   margin-left: 25px;
   }
   
   .chatbot-img-veg{
     height: 90px;
     width: 180px;
     margin-left: 10px;
     margin-top: 10px;
     border-radius: 5px;
   }
   
   .detected-ct-below-doa {
     background-color: rgba(121, 93, 239, 1);
     height: 50px;
     width: 200px;
     color: white;
     font-size: 14px;
     font-family: Graphik;
     font-weight: 500;
     margin-top: 14px;
   text-align: center;
   border-bottom-left-radius: 8px;
   border-bottom-right-radius: 8px;
   padding: 5px;
   }
   .insights-head-doa{
     color: white;
     font-size: 15px;
     font-family: Graphik;
     font-weight: 420;
   text-align: left;
   margin-top: 20px;
   margin-left: 10px;
   }
   
   .insight-button-doa{
     width: 400px;
     display: flex;
     margin-left: 10px;
     margin-top: 10px;
     flex-direction: column;
   }
   .insight-left-button-doa:hover {
     background-color:rgba(116, 123, 169, 1);
     transition: 0.7s;
   }
   .insight-left-button-l-doa:hover {
     background-color:rgba(116, 123, 169, 1);
     transition: 0.7s;
   }
   .insight-left-button-doa{
     height: 30px;
     min-width: 170px;
     max-width: 210px;
     border-radius: 18px;
     border-style: solid;
     border-color: rgba(116, 123, 169, 1);
     border-width: 1px;
     color: white;
     font-size: 12px;
     font-family: Graphik;
     font-weight: 400;
     background-color: 
     rgba(37, 40, 67, 1);
     text-align: center;
     margin-bottom: 10px;
   }
   .insight-left-button-l-doa{
     height: 30px;
     width: 330px;
     border-radius: 18px;
     border-style: solid;
     border-color: rgba(116, 123, 169, 1);
     border-width: 1px;
     color: white;
     font-size: 12px;
     font-family: Graphik;
     font-weight: 400;
     background-color: 
     rgba(37, 40, 67, 1);
     text-align: center;
     margin-bottom: 10px;
   }
   
   .send-icon-veg{
     width:50px;
     height: 90px;
     display: flex;
     flex-direction: column;
     margin-top: 10px;
     padding-top: 35px;
   }
   
   
   .mic-chart-veg {
     padding: 2px;
     width: 25px;
     height: 25px;
     border-radius: 3px;
     border: 1px solid rgba(116, 123, 169, 1);
     background-color: rgba(37, 40, 67, 1);
     margin-bottom: 10px;
   }
   
   .send-chart-veg {
     padding: 2px;
     width: 25px;
     height: 25px;
     margin-bottom: 10px;
     border-radius: 3px;
     border: 1px solid rgba(116, 123, 169, 1);
     background-color: rgba(37, 40, 67, 1);
   }
   
   .bottom-part-chart-veg{
     margin-top: 10px;
     margin-bottom: 10px;
     display: flex;
     width: 100%;
   }
   
   .midside-doa{
     margin-top: 20px;
     border-top: 1px solid  rgba(14, 190, 147, 1);
   }
   
   .message-footer-doa{
     display: flex;
     /* background-color: rgba(116, 123, 169, 1); */
     border: 1px solid  rgba(116, 123, 169, 1);
     height: 34px;  
     justify-content: space-between;
     padding: 5px 10px 5px 10px;
     margin: -10px;
     border-radius: 0px 0px 10px 10px;
     margin-top: 10px;
   }
   .msg-icon-doa{
     width:17px;
     float:right;
     margin-right: 10px;
     padding-top: 2px;
   }
   
   .msg-icon-copy-doa{
     width:12px;
     float:right;
     margin-right: 10px;
     padding-top: 2px;
   }
   
   .msg-icon-share-doa{
     width:15px;
     float:right;
     margin-right: 10px;
     padding-top: 2px;
   }
   
   .border-score-doa{
     margin-left: 10px;
     padding-left: 10px;
     border-left: 1px solid  white;
     height: 20px;
   }
   
   .topside-table-doa{
     width:187px;
     height: 180px;
   }
   
   .cal-data-doa{
     color: white;
     padding: 2px;
     margin-top: 6px;
     margin-left: 10px;
     display: flex;
     flex-direction: row;
   }
   
   .cal-one-doa {
     padding-right: 50px;
     /* justify-content: space-between; */
   }
   
   .cal-row-doa {
     display: flex;
     flex-direction: row;
     font-size: 12px;
     font-family: Graphik;
     padding-top: 10px;
   }
   
   .container-cal-data-doa {
       background-color: #25304C;
       width: 100px;
       height: 30px;
       border-style: solid;
       border-width: 1px;
       border-radius: 5px;
       border-color: #8d97dac5;
       text-align: left;
       padding: 5px;
       color: white
   }
   
   .processebutton-calculate-doa {
     border-radius: 8px;
     margin-right: 40px;
     background-color: rgba(107, 92, 209, 1);
     color: white;
     text-align: center;
     text-decoration: none;
     font-size: 15px;
     width: 140px;
     height: 30px;
     /* border-style: solid; */
     border: 0px solid rgba(107, 92, 209, 1);
     float: right;
     margin-top: 30px;
     margin-bottom: 10px;
   }
   
   .add-data-veg{
     overflow-y: scroll ;
     
     height: 90%;
   }
   
   .table-doa {
     border-collapse: collapse;
     width: 100%;
   }
   
   .table-doa th {
     border: 1px solid rgba(87, 95, 142, 1);
     padding: 8px;
     text-align: center;
     background-color: rgba(60, 64, 105, 1);
   }
   .table-doa td {
     border: 1px solid rgba(87, 95, 142, 1);
     padding: 8px;
     text-align: left;
   }`, "",{"version":3,"sources":["webpack://./src/ChatVeg.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,gBAAgB;;GAEjB;;GAEA;;IAEC,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,YAAY;;;EAGd;;GAEC;KACE,0CAA0C;KAC1C,mBAAmB;KACnB,oBAAoB;KACpB,sBAAsB;KACtB,kBAAkB;KAClB,yBAAyB;KACzB,sBAAsB;KACtB,aAAa;KACb,wBAAwB;KACxB,iBAAiB;KACjB,mBAAmB;KACnB,oCAAoC;KACpC,2CAA2C;KAC3C,uBAAuB;GACzB;;GAEA;KACE,qCAAqC;KACrC,uCAAuC;KACvC,mBAAmB;KACnB,sBAAsB;KACtB,sBAAsB;KACtB;;;0BAGqB;KACrB,uBAAuB;KACvB,aAAa;KACb,sBAAsB;KACtB,aAAa;;GAEf;;GAEA;KACE,eAAe;KACf,iBAAiB;KACjB,eAAe;KACf,oBAAoB;KACpB,gBAAgB;GAClB;;GAEA;KACE,aAAa;GACf;;GAEA;KACE,gBAAgB;KAChB,YAAY;KACZ,qCAAqC;KACrC,eAAe;KACf,gBAAgB;KAChB,iBAAiB;KACjB,oBAAoB;KACpB,iBAAiB;KACjB,YAAY;KACZ,UAAU;KACV,mBAAmB;KACnB,wCAAwC;KACxC,qCAAqC;KACrC,eAAe;GACjB;;GAEA;KACE,iBAAiB;KACjB,kBAAkB;KAClB,gBAAgB;KAChB,YAAY;KACZ,WAAW;KACX,kCAAkC;KAClC,YAAY;KACZ,eAAe;KACf,WAAW;GACb;GACA;KACE,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,YAAY;GACd;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,mBAAmB;KACnB,YAAY;KACZ,YAAY;KACZ,iBAAiB;GACnB;;GAEA;KACE,WAAW;KACX,YAAY;KACZ,aAAa;KACb,kBAAkB;KAClB,qBAAqB;KACrB,2CAA2C;GAC7C;;GAEA;KACE,yBAAyB;KACzB,cAAc;KACd,uBAAuB;GACzB;;GAEA;KACE,yBAAyB;KACzB,gBAAgB;KAChB,uBAAuB;GACzB;;GAEA;KACE,yBAAyB;KACzB,eAAe;GACjB;;GAEA;KACE,yBAAyB;KACzB,cAAc;KACd,uBAAuB;GACzB;;GAEA;;KAEE;;;OAGE,wBAAwB;KAC1B;;KAEA;OACE,4BAA4B;KAC9B;GACF;;GAEA;KACE,iBAAiB;GACnB;;GAEA;KACE,YAAY;KACZ,WAAW;KACX,4BAA4B;KAC5B,6BAA6B;KAC7B,aAAa;KACb,mBAAmB;KACnB,iCAAiC;KACjC,YAAY;KACZ,YAAY;KACZ,eAAe;KACf,gBAAgB;GAClB;;GAEA;KACE,YAAY;KACZ,YAAY;KACZ,eAAe;GACjB;;GAEA;KACE,aAAa;KACb,2BAA2B;KAC3B,wCAAwC;KACxC,aAAa;GACf;;GAEA;KACE,aAAa;KACb,yBAAyB;KACzB,wCAAwC;KACxC,aAAa;GACf;;GAEA;KACE,4BAA4B;KAC5B,eAAe;KACf,YAAY;KACZ,kBAAkB;KAClB,iBAAiB;KACjB,kBAAkB;KAClB,iBAAiB;GACnB;;GAEA,gGAAgG;;GAEhG;KACE,YAAY;KACZ,YAAY;KACZ,eAAe;KACf,kBAAkB;GACpB;GACA;KACE,6BAA6B;KAC7B,oBAAoB;KACpB,yBAAyB;KACzB,4BAA4B;GAC9B;GACA;KACE,aAAa;KACb,kBAAkB;KAClB,mBAAmB;GACrB;;GAEA;KACE,gBAAgB;GAClB;;GAEA;KACE,sBAAsB;KACtB,eAAe;KACf,gBAAgB;KAChB,mBAAmB;KACnB,uBAAuB;KACvB,wBAAwB;KACxB,gBAAgB;KAChB,kBAAkB;KAClB,gBAAgB;KAChB,mBAAmB;KACnB,kBAAkB;KAClB,WAAW;GACb;;GAEA;KACE,eAAe;KACf,gBAAgB;KAChB,kBAAkB;KAClB,gBAAgB;KAChB,mBAAmB;KACnB,sBAAsB;KACtB,sBAAsB;KACtB,yBAAyB;KACzB,oBAAoB;KACpB,oBAAoB;KACpB,aAAa;KACb,YAAY;KACZ,gBAAgB;KAChB,wBAAwB;KACxB,kBAAkB;KAClB,WAAW;GACb;;GAEA;KACE,wCAAwC;KACxC,iCAAiC;KACjC,wBAAwB;KACxB,eAAe;KACf,iBAAiB;GACnB;;GAEA;KACE,qCAAqC;KACrC,iCAAiC;KACjC,eAAe;KACf,iBAAiB;KACjB,kBAAkB;GACpB;;GAEA;KACE,WAAW;KACX,kBAAkB;KAClB,iBAAiB;KACjB,wBAAwB;KACxB,mBAAmB;KACnB,gBAAgB;GAClB;;GAEA;KACE,WAAW;KACX,kBAAkB;KAClB,wBAAwB;KACxB,mBAAmB;KACnB,iBAAiB;GACnB;;GAEA;KACE,YAAY;KACZ,iBAAiB;KACjB,mBAAmB;KACnB,eAAe;KACf,oBAAoB;KACpB,gBAAgB;KAChB,gBAAgB;KAChB,gBAAgB;KAChB,iBAAiB;KACjB,mBAAmB;GACrB;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,mBAAmB;GACrB;;GAEA;KACE,WAAW;GACb;;GAEA;KACE,wFAAwF;KACxF,aAAa;KACb,YAAY;KACZ,iBAAiB;KACjB,kBAAkB;KAClB,gBAAgB;KAChB,mBAAmB;GACrB;GACA;KACE,YAAY;KACZ,eAAe;KACf,YAAY;KACZ,oBAAoB;KACpB,gBAAgB;GAClB,kBAAkB;GAClB,YAAY;GACZ,iBAAiB;GACjB;;GAEA;KACE,YAAY;KACZ,YAAY;KACZ,iBAAiB;KACjB,gBAAgB;KAChB,kBAAkB;GACpB;;GAEA;KACE,uCAAuC;KACvC,YAAY;KACZ,YAAY;KACZ,YAAY;KACZ,eAAe;KACf,oBAAoB;KACpB,gBAAgB;KAChB,gBAAgB;GAClB,kBAAkB;GAClB,8BAA8B;GAC9B,+BAA+B;GAC/B,YAAY;GACZ;GACA;KACE,YAAY;KACZ,eAAe;KACf,oBAAoB;KACpB,gBAAgB;GAClB,gBAAgB;GAChB,gBAAgB;GAChB,iBAAiB;GACjB;;GAEA;KACE,YAAY;KACZ,aAAa;KACb,iBAAiB;KACjB,gBAAgB;KAChB,sBAAsB;GACxB;GACA;KACE,uCAAuC;KACvC,gBAAgB;GAClB;GACA;KACE,uCAAuC;KACvC,gBAAgB;GAClB;GACA;KACE,YAAY;KACZ,gBAAgB;KAChB,gBAAgB;KAChB,mBAAmB;KACnB,mBAAmB;KACnB,oCAAoC;KACpC,iBAAiB;KACjB,YAAY;KACZ,eAAe;KACf,oBAAoB;KACpB,gBAAgB;KAChB;wBACmB;KACnB,kBAAkB;KAClB,mBAAmB;GACrB;GACA;KACE,YAAY;KACZ,YAAY;KACZ,mBAAmB;KACnB,mBAAmB;KACnB,oCAAoC;KACpC,iBAAiB;KACjB,YAAY;KACZ,eAAe;KACf,oBAAoB;KACpB,gBAAgB;KAChB;wBACmB;KACnB,kBAAkB;KAClB,mBAAmB;GACrB;;GAEA;KACE,UAAU;KACV,YAAY;KACZ,aAAa;KACb,sBAAsB;KACtB,gBAAgB;KAChB,iBAAiB;GACnB;;;GAGA;KACE,YAAY;KACZ,WAAW;KACX,YAAY;KACZ,kBAAkB;KAClB,wCAAwC;KACxC,qCAAqC;KACrC,mBAAmB;GACrB;;GAEA;KACE,YAAY;KACZ,WAAW;KACX,YAAY;KACZ,mBAAmB;KACnB,kBAAkB;KAClB,wCAAwC;KACxC,qCAAqC;GACvC;;GAEA;KACE,gBAAgB;KAChB,mBAAmB;KACnB,aAAa;KACb,WAAW;GACb;;GAEA;KACE,gBAAgB;KAChB,4CAA4C;GAC9C;;GAEA;KACE,aAAa;KACb,8CAA8C;KAC9C,yCAAyC;KACzC,YAAY;KACZ,8BAA8B;KAC9B,0BAA0B;KAC1B,aAAa;KACb,gCAAgC;KAChC,gBAAgB;GAClB;GACA;KACE,UAAU;KACV,WAAW;KACX,kBAAkB;KAClB,gBAAgB;GAClB;;GAEA;KACE,UAAU;KACV,WAAW;KACX,kBAAkB;KAClB,gBAAgB;GAClB;;GAEA;KACE,UAAU;KACV,WAAW;KACX,kBAAkB;KAClB,gBAAgB;GAClB;;GAEA;KACE,iBAAiB;KACjB,kBAAkB;KAClB,6BAA6B;KAC7B,YAAY;GACd;;GAEA;KACE,WAAW;KACX,aAAa;GACf;;GAEA;KACE,YAAY;KACZ,YAAY;KACZ,eAAe;KACf,iBAAiB;KACjB,aAAa;KACb,mBAAmB;GACrB;;GAEA;KACE,mBAAmB;KACnB,oCAAoC;GACtC;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,eAAe;KACf,oBAAoB;KACpB,iBAAiB;GACnB;;GAEA;OACI,yBAAyB;OACzB,YAAY;OACZ,YAAY;OACZ,mBAAmB;OACnB,iBAAiB;OACjB,kBAAkB;OAClB,uBAAuB;OACvB,gBAAgB;OAChB,YAAY;OACZ;GACJ;;GAEA;KACE,kBAAkB;KAClB,kBAAkB;KAClB,uCAAuC;KACvC,YAAY;KACZ,kBAAkB;KAClB,qBAAqB;KACrB,eAAe;KACf,YAAY;KACZ,YAAY;KACZ,yBAAyB;KACzB,uCAAuC;KACvC,YAAY;KACZ,gBAAgB;KAChB,mBAAmB;GACrB;;GAEA;KACE,mBAAmB;;KAEnB,WAAW;GACb;;GAEA;KACE,yBAAyB;KACzB,WAAW;GACb;;GAEA;KACE,sCAAsC;KACtC,YAAY;KACZ,kBAAkB;KAClB,sCAAsC;GACxC;GACA;KACE,sCAAsC;KACtC,YAAY;KACZ,gBAAgB;GAClB","sourcesContent":[".chatbot-container-veg {\n    margin-left: 0px;\n    width: 1000vh;\n    margin-top: 20px;\n    \n   }\n\n   .chatboticon-v {\n  \n    float: right;\n    margin-left: 60px;\n  }\n\n  .top-sum-v{\n    width: 5%;\n    margin-left: 850px;\n    float: right;\n    \n    \n  }\n   \n   .right-section-chat-veg {\n     /* background-color: rgba(0, 0, 0, 0.1); */\n     border-radius: 10px;\n     /* min-width: 550; */\n     /* margin-top: 20px; */\n     /* padding: 5px; */\n     /* margin-bottom: 20px; */\n     /* margin-left: 5px; */\n     height: 470px;\n     /* border-radius: 8px; */\n     border-width: 1px;\n     border-style: solid;\n     border-color: rgba(116, 123, 169, 1);\n     background-color: rgba(255, 255, 255, 0.05);\n     /* max-height: 450px; */\n   }\n   \n   .left-section-chat-veg {\n     background-color: rgba(30, 32, 61, 1);\n     border: 1px solid rgba(107, 92, 209, 1);\n     border-radius: 10px;\n     /* min-width: 500px; */\n     /* min-width: 680px; */\n     /* margin-left: 7px;\n     margin-top: 20px;\n     margin-bottom: 20px;\n     margin-right: 20px; */\n     /* max-height: 450px; */\n     display: flex;\n     flex-direction: column;\n     height: 470px;\n   \n   }\n   \n   .title-chart-veg {\n     margin-top: 5px;\n     margin-left: 10px;\n     font-size: 13px;\n     font-family: Graphik;\n     font-weight: 400;\n   }\n   \n   .chat-input-container-chart-veg {\n     display: flex;\n   }\n   \n   .text-chart-veg {\n     margin-top: 30px;\n     color: white;\n     background-color: rgba(37, 40, 67, 1);\n     font-size: 14px;\n     font-weight: 300;\n     margin-right: 5px;\n     font-family: Graphik;\n     padding-left: 7px;\n     height: 50px;\n     width:100%;\n     border-radius: 10px;\n     border: 1px solid rgba(116, 123, 169, 1);\n     background-color: rgba(37, 40, 67, 1);\n     text-align:left;\n   }\n   \n   .chat-input-chart-veg {\n     margin-left: 10px;\n     margin-right: 10px;\n     margin-top: 10px;\n     padding: 2px;\n     width: 100%;\n     font-family: 'Graphik', sans-serif;\n     color: black;\n     font-size: 14px;\n     height: 10%;\n   }\n   .loader-doa {\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     height: 40px;\n   }\n   \n   .loader-f-doa {\n     display: flex;\n     flex-direction: row;\n     justify-content: center;\n     align-items: center;\n     height: 40px;\n     width: 187px;\n     padding-top: 80px;\n   }\n   \n   .dot-doa {\n     width: 10px;\n     height: 10px;\n     margin: 0 5px;\n     border-radius: 50%;\n     display: inline-block;\n     animation: bounce 1.4s infinite ease-in-out;\n   }\n   \n   .red-doa {\n     background-color: #8070d4;\n     /* Red color */\n     animation-delay: -0.32s;\n   }\n   \n   .green-doa {\n     background-color: #8070d4;\n     /* Green color */\n     animation-delay: -0.16s;\n   }\n   \n   .blue-doa {\n     background-color: #8070d4;\n     /* Blue color */\n   }\n   \n   .loading-text-doa {\n     background-color: #3498db;\n     /* Red color */\n     animation-delay: -0.48s;\n   }\n   \n   @keyframes bounce {\n   \n     0%,\n     80%,\n     100% {\n       transform: translateY(0);\n     }\n   \n     40% {\n       transform: translateY(-10px);\n     }\n   }\n   \n   .img1-chart-veg {\n     text-align: right;\n   }\n   \n   .top-part-chart-veg {\n     height: 40px;\n     width: 100%;\n     border-top-left-radius: 10px;\n     border-top-right-radius: 10px;\n     display: flex;\n     flex-direction: row;\n     background-color: rgb(54, 54, 89);\n     padding: 5px;\n     color: white;\n     font-size: 13px;\n     font-weight: 500;\n   }\n   \n   .middile-part-chart-veg {\n     height: auto;\n     color: white;\n     font-size: 10px;\n   }\n   \n   .user-message-container-veg {\n     display: flex;\n     justify-content: flex-start;\n     /* Align to the left for user messages */\n     margin: 5px 0;\n   }\n   \n   .bot-message-container-veg {\n     display: flex;\n     justify-content: flex-end;\n     /* Align to the right for bot messages */\n     margin: 5px 0;\n   }\n   \n   .message-text-chart-veg {\n     padding: 10px 10px 10px 10px;\n     font-size: 14px;\n     color: white;\n     border-radius: 5px;\n     max-width: 1000px;\n     width: fit-content;\n     margin-left: 30px;\n   }\n   \n   /* Additional styles for user and bot message containers, e.g., background color, border, etc. */\n   \n   .chat-messages-c-veg {\n     height: 100%;\n     color: white;\n     font-size: 16px;\n     overflow-y: scroll;\n   }\n   .section::-webkit-scrollbar-thumb {\n     border: 5px solid transparent;\n     border-radius: 100px;\n     background-color: #8070d4;\n     background-clip: content-box;\n   }\n   .chat-message-chart-veg {\n     display: flex;\n     border-radius: 5px;\n     flex-direction: row;\n   }\n   \n   .chat-message-chart-veg.user-c-veg {\n     text-align: left;\n   }\n   \n   .user-c-veg {\n     /* align-items: end; */\n     min-width: 50px;\n     margin-top: 10px;\n     margin-bottom: 10px;\n     /* margin-right:10px; */\n     /* margin-left: 100px; */\n     text-align: left;\n     position: relative;\n     max-width: 500px;\n     /* padding: 10px; */\n     width: fit-content;\n     float: left;\n   }\n   \n   .bot-c-veg {\n     min-width: 50px;\n     margin-top: 10px;\n     position: relative;\n     max-width: 640px;\n     margin-bottom: 10px;\n     /* min-height: 60px; */\n     /* max-height: 100%; */\n     /* height: fit-content; */\n     /* display: block; */\n     /* overflow: auto; */\n     padding: 10px;\n     color: white;\n     text-align: left;\n     /* margin-right: 30px; */\n     width: fit-content;\n     float: left;\n   }\n   \n   .bg-user-veg {\n     background-color: rgba(116, 123, 169, 1);\n     border-radius: 0px 10px 10px 10px;\n     border-style: icon solid;\n     min-width: 50px;\n     margin-left: 40px;\n   }\n   \n   .bg-bot-veg {\n     background-color: rgba(45, 50, 90, 1);\n     border-radius: 0px 10px 10px 10px;\n     min-width: 50px;\n     max-width: 1200px;\n     /* height: auto; */\n   }\n   \n   .icon-chat-user-veg {\n     width: 25px;\n     position: absolute;\n     margin-left: 10px;\n     /* margin-right: 10px; */\n     /* bottom: -15px; */\n     /* left: -5px; */\n   }\n   \n   .icon-chat-bot-veg {\n     width: 25px;\n     position: absolute;\n     /* margin-right: 50px; */\n     /* bottom: -15px; */\n     /* right: -5px; */\n   }\n   \n   .key-table-cb-doa {\n     color: white;\n     padding-top: 15px;\n     padding-bottom: 5px;\n     font-size: 13px;\n     font-family: Graphik;\n     font-weight: 400;\n     margin-top: 27px;\n     margin-left: 6px;\n     line-height: 40px;\n     margin-bottom: 10px;\n   }\n   \n   .topside-doa {\n     display: flex;\n     flex-direction: row;\n     margin-bottom: 10px;\n   }\n   \n   .chat-table-doa {\n     width: 20px;\n   }\n   \n   .detected-ct-doa {\n     background-image: linear-gradient(to right, rgba(72, 48, 239, 1), rgba(128, 69, 237, 1));\n     height: 140px;\n     width: 200px;\n     margin-left: 15px;\n     border-radius: 8px;\n     margin-top: 10px;\n     margin-bottom: 10px;\n   }\n   .heading-dt-doa{\n     color: white;\n     font-size: 14px;\n     height: 30px;\n     font-family: Graphik;\n     font-weight: 500;\n   text-align: center;\n   width: 150px;\n   margin-left: 25px;\n   }\n   \n   .chatbot-img-veg{\n     height: 90px;\n     width: 180px;\n     margin-left: 10px;\n     margin-top: 10px;\n     border-radius: 5px;\n   }\n   \n   .detected-ct-below-doa {\n     background-color: rgba(121, 93, 239, 1);\n     height: 50px;\n     width: 200px;\n     color: white;\n     font-size: 14px;\n     font-family: Graphik;\n     font-weight: 500;\n     margin-top: 14px;\n   text-align: center;\n   border-bottom-left-radius: 8px;\n   border-bottom-right-radius: 8px;\n   padding: 5px;\n   }\n   .insights-head-doa{\n     color: white;\n     font-size: 15px;\n     font-family: Graphik;\n     font-weight: 420;\n   text-align: left;\n   margin-top: 20px;\n   margin-left: 10px;\n   }\n   \n   .insight-button-doa{\n     width: 400px;\n     display: flex;\n     margin-left: 10px;\n     margin-top: 10px;\n     flex-direction: column;\n   }\n   .insight-left-button-doa:hover {\n     background-color:rgba(116, 123, 169, 1);\n     transition: 0.7s;\n   }\n   .insight-left-button-l-doa:hover {\n     background-color:rgba(116, 123, 169, 1);\n     transition: 0.7s;\n   }\n   .insight-left-button-doa{\n     height: 30px;\n     min-width: 170px;\n     max-width: 210px;\n     border-radius: 18px;\n     border-style: solid;\n     border-color: rgba(116, 123, 169, 1);\n     border-width: 1px;\n     color: white;\n     font-size: 12px;\n     font-family: Graphik;\n     font-weight: 400;\n     background-color: \n     rgba(37, 40, 67, 1);\n     text-align: center;\n     margin-bottom: 10px;\n   }\n   .insight-left-button-l-doa{\n     height: 30px;\n     width: 330px;\n     border-radius: 18px;\n     border-style: solid;\n     border-color: rgba(116, 123, 169, 1);\n     border-width: 1px;\n     color: white;\n     font-size: 12px;\n     font-family: Graphik;\n     font-weight: 400;\n     background-color: \n     rgba(37, 40, 67, 1);\n     text-align: center;\n     margin-bottom: 10px;\n   }\n   \n   .send-icon-veg{\n     width:50px;\n     height: 90px;\n     display: flex;\n     flex-direction: column;\n     margin-top: 10px;\n     padding-top: 35px;\n   }\n   \n   \n   .mic-chart-veg {\n     padding: 2px;\n     width: 25px;\n     height: 25px;\n     border-radius: 3px;\n     border: 1px solid rgba(116, 123, 169, 1);\n     background-color: rgba(37, 40, 67, 1);\n     margin-bottom: 10px;\n   }\n   \n   .send-chart-veg {\n     padding: 2px;\n     width: 25px;\n     height: 25px;\n     margin-bottom: 10px;\n     border-radius: 3px;\n     border: 1px solid rgba(116, 123, 169, 1);\n     background-color: rgba(37, 40, 67, 1);\n   }\n   \n   .bottom-part-chart-veg{\n     margin-top: 10px;\n     margin-bottom: 10px;\n     display: flex;\n     width: 100%;\n   }\n   \n   .midside-doa{\n     margin-top: 20px;\n     border-top: 1px solid  rgba(14, 190, 147, 1);\n   }\n   \n   .message-footer-doa{\n     display: flex;\n     /* background-color: rgba(116, 123, 169, 1); */\n     border: 1px solid  rgba(116, 123, 169, 1);\n     height: 34px;  \n     justify-content: space-between;\n     padding: 5px 10px 5px 10px;\n     margin: -10px;\n     border-radius: 0px 0px 10px 10px;\n     margin-top: 10px;\n   }\n   .msg-icon-doa{\n     width:17px;\n     float:right;\n     margin-right: 10px;\n     padding-top: 2px;\n   }\n   \n   .msg-icon-copy-doa{\n     width:12px;\n     float:right;\n     margin-right: 10px;\n     padding-top: 2px;\n   }\n   \n   .msg-icon-share-doa{\n     width:15px;\n     float:right;\n     margin-right: 10px;\n     padding-top: 2px;\n   }\n   \n   .border-score-doa{\n     margin-left: 10px;\n     padding-left: 10px;\n     border-left: 1px solid  white;\n     height: 20px;\n   }\n   \n   .topside-table-doa{\n     width:187px;\n     height: 180px;\n   }\n   \n   .cal-data-doa{\n     color: white;\n     padding: 2px;\n     margin-top: 6px;\n     margin-left: 10px;\n     display: flex;\n     flex-direction: row;\n   }\n   \n   .cal-one-doa {\n     padding-right: 50px;\n     /* justify-content: space-between; */\n   }\n   \n   .cal-row-doa {\n     display: flex;\n     flex-direction: row;\n     font-size: 12px;\n     font-family: Graphik;\n     padding-top: 10px;\n   }\n   \n   .container-cal-data-doa {\n       background-color: #25304C;\n       width: 100px;\n       height: 30px;\n       border-style: solid;\n       border-width: 1px;\n       border-radius: 5px;\n       border-color: #8d97dac5;\n       text-align: left;\n       padding: 5px;\n       color: white\n   }\n   \n   .processebutton-calculate-doa {\n     border-radius: 8px;\n     margin-right: 40px;\n     background-color: rgba(107, 92, 209, 1);\n     color: white;\n     text-align: center;\n     text-decoration: none;\n     font-size: 15px;\n     width: 140px;\n     height: 30px;\n     /* border-style: solid; */\n     border: 0px solid rgba(107, 92, 209, 1);\n     float: right;\n     margin-top: 30px;\n     margin-bottom: 10px;\n   }\n   \n   .add-data-veg{\n     overflow-y: scroll ;\n     \n     height: 90%;\n   }\n   \n   .table-doa {\n     border-collapse: collapse;\n     width: 100%;\n   }\n   \n   .table-doa th {\n     border: 1px solid rgba(87, 95, 142, 1);\n     padding: 8px;\n     text-align: center;\n     background-color: rgba(60, 64, 105, 1);\n   }\n   .table-doa td {\n     border: 1px solid rgba(87, 95, 142, 1);\n     padding: 8px;\n     text-align: left;\n   }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
